import Cookies from "universal-cookie";

export default function getParameter(paramName) {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const cookies = new Cookies();
  const cookieName = paramName;

  if (
    !window.location.pathname.includes("register") &&
    params.get(paramName) == ""
  ) {
    cookies.remove(cookieName);
  }

  if (
    (window.location.pathname.includes("register") &&
    cookies.get(cookieName) != null &&
    params.get(paramName) == "") || (window.location.pathname.includes("register") &&
    cookies.get(cookieName) != null &&
    params.get(paramName) === null)
  ) {
    return cookies.get(cookieName);
  }

  if (params.get(paramName) != null && params.get(paramName) != "") {
    cookies.remove(cookieName);
    cookies.set(cookieName, params.get(paramName), { path: "/wps/portal/web" });
  }
  return params.get(paramName);
}
